import React from 'react';
// import PropTypes from 'prop-types';

import {Routes, Route, Navigate} from 'react-router';

import Authentication from './auth/Authentication';
import MagicLinkRedirect from './magic-link/MagicLinkRedirect';
import CaregiverScreener from './caregiver_screening/CaregiverScreener';
import CaregiverForm from './caregiver_form/CaregiverForm';
import CaregiverApplicationLanding from './caregiver_screening/CaregiverApplicationLanding';
import CaregiverInterview from './caregiver_interview/CaregiverInterview';

import Profile from './caregiver/CaregiverProfile';

import JobBoard from './jobs/JobBoard';
import JobDetailScene from './jobs/JobDetail';

const Router = () => {
  return (
    <Routes>
      <Route path="/signout" element={<Navigate to="/" />} />

      <Route path="/caregiver-application" element={<CaregiverForm />} />

      <Route path="/caregiver-onboarding" element={<CaregiverApplicationLanding />} />
      <Route path='/caregiver-onboarding/form' element={<CaregiverScreener />} />

      <Route path='/caregiver-form' element={<CaregiverInterview />}/>

      <Route path="/magic-link" element={<MagicLinkRedirect />} />

      <Route path='/caregivers/:caregiverRn' element={<Profile />} />

      <Route path='/job' element={<JobBoard />} />
      <Route path='/job/:jobRn' element={<JobDetailScene />} />

      <Route path="/welcome" element={<Authentication />} />

      <Route path="*" Component={CaregiverForm} />
    </Routes>
  );
};

Router.propTypes = {
};

export default React.memo(Router);

